import {createAction, props} from '@ngrx/store';
import {ActionCreator, TypedAction} from '@ngrx/store/src/models';
import {Serializers} from '../../interfaces/serializer';
import {DataSourceProvider} from './dataSourceProviders';

export const loadDataSourceProviders: ActionCreator<'[DATA_SOURCE_PROVIDERS] Load', () => TypedAction<'[DATA_SOURCE_PROVIDERS] Load'>> = createAction('[DATA_SOURCE_PROVIDERS] Load');

export const loadDataSourceProvidersSuccess: ActionCreator<
  '[DATA_SOURCE_PROVIDERS] Load success',
  (props: { dataSources: Serializers<DataSourceProvider> }) => TypedAction<'[DATA_SOURCE_PROVIDERS] Load success'> & { dataSources: Serializers<DataSourceProvider> }
> = createAction('[DATA_SOURCE_PROVIDERS] Load success', props<{ dataSources: Serializers<DataSourceProvider> }>());
